import { createFileRoute } from '@tanstack/react-router'

import VerifyForm from '@/screens/auth/VerifyForm'

/**
 * Reached only from /signup, which leaves the new account's id and credentials
 * in memory for it. Nothing is carried in the URL — a user id in a query string
 * is an invitation to brute-force OTPs against someone else's sign-up — so a
 * deep link or a reload arrives empty and the screen says so.
 */
export const Route = createFileRoute('/_auth/verify')({ component: VerifyForm })
